var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TransientMarkerBoxAdapter_terminator, _TransientMarkerBoxAdapter_box, _TransientMarkerBoxAdapter_notifer;
import { Notifier, Terminator } from "@opendaw/lib-std";
export class TransientMarkerBoxAdapter {
    constructor(box) {
        this.type = "transient-marker";
        _TransientMarkerBoxAdapter_terminator.set(this, new Terminator());
        _TransientMarkerBoxAdapter_box.set(this, void 0);
        _TransientMarkerBoxAdapter_notifer.set(this, void 0);
        __classPrivateFieldSet(this, _TransientMarkerBoxAdapter_box, box, "f");
        __classPrivateFieldSet(this, _TransientMarkerBoxAdapter_notifer, new Notifier(), "f");
    }
    get box() { return __classPrivateFieldGet(this, _TransientMarkerBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _TransientMarkerBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _TransientMarkerBoxAdapter_box, "f").address; }
    get position() { return __classPrivateFieldGet(this, _TransientMarkerBoxAdapter_box, "f").position.getValue(); }
    subscribe(observer) { return __classPrivateFieldGet(this, _TransientMarkerBoxAdapter_notifer, "f").subscribe(observer); }
    terminate() { __classPrivateFieldGet(this, _TransientMarkerBoxAdapter_terminator, "f").terminate(); }
}
_TransientMarkerBoxAdapter_terminator = new WeakMap(), _TransientMarkerBoxAdapter_box = new WeakMap(), _TransientMarkerBoxAdapter_notifer = new WeakMap();
